<template>
  <Layout>
    <!-- Header -->
    <div class="row">
      <div class="col-10">
        <PageHeader title="Automatic Traffic Counter cum Classifier" />
      </div>
      <div class="col-2">
        <button type="button" :class="isDataFilterActive
          ? 'btn btn-success toggle-atcc-filter w-100'
          : 'btn btn-primary toggle-atcc-filter w-100'
          " @click="toggleFilter">
          <span v-if="!isDataFilterActive"><i class="bx bx-cog bx-spin toggle-atcc-filter"></i> Select Filters
          </span>
          <span v-else><i class="bx bx-check toggle-atcc-filter mr-4"></i>Filters
            Applied</span>
        </button>
      </div>
    </div>
    <hr />
    <!-- Statistics -->
    <div class="row">
      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  {{
                    $t("menuitems.incident.list.atccEvents.list.todayTraffic")
                  }}
                </p>
                <h5 class="mb-0" v-if="atccStats">
                  {{ atccStats.todayTrafficCount }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-danger font-size-20">
                  <i class="bx bxs-car"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  {{ $t("menuitems.incident.list.atccEvents.list.monthTraffic") }}
                </p>
                <h5 class="mb-0" v-if="atccStats">
                  {{ atccStats.monthTrafficCount }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-warning font-size-20">
                  <i class="bx bxs-folder-open"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  {{
                    $t("menuitems.incident.list.atccEvents.list.yearlyTraffic")
                  }}
                </p>
                <h5 class="mb-0" v-if="atccStats">
                  {{ atccStats.yearTrafficCount }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-success font-size-20">
                  <i class="bx bxs-check-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  {{
                    $t("menuitems.incident.list.atccEvents.list.totalTraffic")
                  }}
                </p>
                <h5 class="mb-0" v-if="atccStats">
                  {{ atccStats.totalTrafficCount }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                  <i class="bx bxs-file"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Incidents Table -->
    <Loader>
      <div class="table-responsive mb-0">
        <b-table class="datatables" :items="allTrafficData" :fields="fields" responsive="sm" :per-page="0"
          :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
          :filter-included-fields="filterOn" @filtered="onFiltered">
          <template #cell(plate_no)="row">
            {{ !row.item.plate_no ? "Unknown" : row.item.plate_no }}
          </template>

          <template #cell(veh_image_url)="row">
            <img v-if="row.item.veh_image_url !== 'NA'" :src="`${config.CLIENT_URL}${row.item.veh_image_url}`" width="80"
              @click="
                showImage(`${config.CLIENT_URL}${row.item.veh_image_url}`)
                " style="cursor: pointer" />
            <span v-else>Not Available</span>
          </template>
          <template #cell(actions)="row">
            <button class="btn btn-sm btn-primary m-2"
              @click="$router.push(`/incident/view-atcc-details/${row.item.id}`)">
              View Details <i class="fa fa-arrow-right ms-1"></i>
            </button>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end mb-3">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </Loader>

    <!-- Incident details modal -->
    <b-modal id="more-details-modal" size="xl" title-class="font-18" hide-footer centered>
      <template #modal-header>
        <div>
          <h5>Incident Details</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-primary m-2" disabled>
            Status: {{ selectedIncident.status }}
          </button>
          <button class="btn btn-sm btn-outline-danger m-2" @click="$bvModal.hide('more-details-modal')">
            <i class="mdi mdi-close"></i> Close
          </button>
        </div>
      </template>

      <div class="row">
        <div class="col-xl-6">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Incident Id</th>
                      <td>{{ selectedIncident.id }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Vehicle Number</th>
                      <td contenteditable @input="onInput">
                        {{
                          selectedIncident.vehicle_no != ""
                          ? selectedIncident.vehicle_no
                          : "NA"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Vehicle Class</th>
                      <td>
                        <v-select v-model="selectedIncident.class_name" :options="masters.vehicleClass" label="class_name"
                          :reduce="(vc) => vc.class_name"></v-select>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Incident Category</th>
                      <td>
                        {{
                          selectedIncident.category_name != ""
                          ? selectedIncident.category_name
                          : "NA"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Sub Category</th>
                      <td>{{ selectedIncident.sub_category_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Source</th>
                      <td>{{ selectedIncident.source_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Description</th>
                      <td>{{ selectedIncident.description }}</td>
                    </tr>
                    <tr v-show="selectedIncident.category_name === 'Accident'">
                      <th scope="row">Chainage Number</th>
                      <td>{{ selectedIncident.ch_no }}</td>
                    </tr>
                    <tr v-show="selectedIncident.category_name === 'Accident'">
                      <th scope="row">Side</th>
                      <td>{{ selectedIncident.side_name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Assigned To</th>
                      <td>
                        <v-select v-model="selectedIncident.reported_to_name" :options="options.informedTo"
                          label="firstName" :reduce="(vc) => vc.firstName"></v-select>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Challan Status</th>
                      <td>
                        {{ selectedIncident.challan_status }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Incident Date/Time</th>
                      <td>
                        {{
                          getReadableDateTime(
                            selectedIncident.incident_datetime
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Reported Date/Time</th>
                      <td>
                        {{
                          new Date(
                            selectedIncident.reported_datetime
                          ).toLocaleString()
                        }}
                      </td>
                    </tr>
                    <tr v-show="selectedIncident.category_name === 'Accident'">
                      <th scope="row">Informed To</th>
                      <td>{{ selectedIncident.reported_to_name }}</td>
                    </tr>

                    <tr v-show="selectedIncident.category_name === 'Accident'">
                      <th scope="row">Driver Name</th>
                      <td>{{ selectedIncident.driver_name }}</td>
                    </tr>
                    <tr v-show="selectedIncident.category_name === 'Accident'">
                      <th scope="row">No. of Injured People</th>
                      <td>{{ selectedIncident.injured_count }}</td>
                    </tr>
                    <tr v-show="selectedIncident.category_name === 'Accident'">
                      <th scope="row">Response Date/Time</th>
                      <td>{{ selectedIncident.response_datetime }}</td>
                    </tr>
                    <tr v-show="selectedIncident.category_name === 'Accident'">
                      <th scope="row">RPO Comment</th>
                      <td>{{ selectedIncident.comment }}</td>
                    </tr>
                    <tr v-show="selectedIncident.status !== 'Open'">
                      <th scope="row">Close Date/Time</th>
                      <td>{{ selectedIncident.close_datetime }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Incident Photos</h4>
              <img v-for="(src, index) in vehicleImages" :key="index" class="float-left image"
                @click="() => showCaptiomImg(index)" width="150" :src="src" />
            </div>
            <vue-easy-lightbox :visible="visibleCaption" :imgs="vehicleImages" :index="index"
              @hide="handleCaptionHide"></vue-easy-lightbox>
          </div>
        </div>
        <div class="col-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Speed Details</h4>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Raise new incident modal -->
    <b-modal id="raise-new-incident-modal" title="Raise Challan" title-class="font-18" size="lg" no-close-on-backdrop
      hide-footer centered>
      <template #modal-header>
        <div>
          <h5>Raise New Incident</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('raise-new-incident-modal')">
            Cancel
          </button>
        </div>
      </template>
      <RaiseNewIncident @closeModal="$bvModal.hide('raise-new-incident-modal')" />
    </b-modal>

    <!-- Quick image preview -->
    <vue-easy-lightbox :visible="showSingleImage" :imgs="selectedImage" :index="index"
      @hide="handleCaptionHide"></vue-easy-lightbox>

    <AtccFilter :vehicleClassOptions="masters.vehicleClass" :sitesFilters="sitesFilters"
      :locationOptions="locationFilters" @close="toggleFilter" @getFilteredRecords="getFilteredRecords"
      @resetFilter="resetFilter" />
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import RaiseNewIncident from "./raise-incident.vue";
import DatePicker from "vue2-datepicker";
import VueEasyLightbox from "vue-easy-lightbox";
import Swal from "sweetalert2";
import rpoMap from "../../views/incident/rpoVehicleMap.vue";
import atccMixin from "../../mixins/atcc";
import incidentMixin from "../../mixins/incident";
import "../../assets/plugins/range-slider/vue-range-slider.css";
import VueRangeSlider from "../../assets/plugins/range-slider/vue-range-slider";
import Loader from "../../components/widgets/loader.vue";
import AtccFilter from "@/components/incidents/atcc-filter";
import config from "../../constants/config";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Automatic Traffic Counter and Classifier",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [atccMixin, incidentMixin],

  components: {
    Layout,
    PageHeader,
    RaiseNewIncident,
    VueEasyLightbox,
    rpoMap,
    DatePicker,
    VueRangeSlider,
    Loader,
    AtccFilter,
  },

  data () {
    return {
      config: config,
      selectedImage: null,
      showSingleImage: false,
      isDataFilterActive: false,
      speedFilter: [0, 500],
      currentChallanModalId: null,
      filterVehicleNumber: null,
      filterVehicleSpeed: 0,
      filterVehicleClass: null,
      datepickervalueFrom: null,
      datepickervalueTo: null,
      packageFilter: null,
      subCategoryId: null,
      vehicleNumber: null,
      vehicleClass: null,
      allTrafficData: [],
      locationFilters: [],
      sidesFilters: [],
      sitesFilters: [],
      incidentId: null,
      visibleCaption: false,
      selectedIncident: {},
      resolveComment: "",
      index: 1,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "id",
      sortDesc: true,
      filterOn: [],
      filter: null,
      offenceId: null,
      dpCd: null,
      latitude: null,
      voilationSource: null,
      stateCd: null,
      districtId: null,
      offCd: null,
      equipmentId: null,
      vendorName: null,
      vehicleSpeed: 0,
      speedLimit: null,
      vehicleWeight: null,
      voilationTime: null,
      actionTime: null,
      longitude: null,
      operatorId: null,

      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "plate_no",
          label: "Plate No.",
          sortable: false,
        },
        {
          key: "location",
          label: "Location",
          sortable: true,
          formatter: (value) => {
            return value ? value : "Unknown";
          },
        },
        {
          key: "side",
          label: "Direction",
          sortable: true,
          formatter: (value) => {
            return value ? value : "Unknown";
          },
        },
        {
          key: "class_id",
          label: "Veh. Class",
          sortable: false,
          formatter: (value) => {
            const obj = this.masters.vehicleClass.find((v) => v.id == value);
            return obj ? obj.class_name : "Unknown";
          },
        },
        {
          key: "vehicle_speed",
          label: "Speed",
          sortable: true,
          formatter: (value) => {
            return Math.round(value).toFixed(0) != 0 ? Math.round(value).toFixed(0) + ' km/hr' : 'NA';
          },
        },
        {
          key: "confidence",
          label: "Confidence",
          sortable: false,
          formatter: (value) => {
            return `${(value * 100).toFixed(0)}%`;
          },
        },
        {
          key: "reported_datetime",
          label: "Timestamp",
          thStyle: { width: "10%" },
          sortable: true,
          formatter: (value) => {
            return this.getReadableDateTime(value);
          },
        },
        {
          key: "veh_image_url",
          label: "Image",
          sortable: false,
          formatter: (value) => {
            return value ? value : "NA";
          },
        },
        {
          key: "actions",
          sortable: false,
          label: "Action",
        },
      ],

      options: {
        informedTo: [],
      },

      socketInterval: null,
    };
  },

  methods: {
    showImage (imageUrl) {
      this.selectedImage = [imageUrl];
      this.showSingleImage = true;
    },

    toggleFilter () {
      document.body.classList.toggle("atcc-right-bar-enabled");
    },

    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getReadableDateTime (dateTime) {
      if (dateTime) {
        // const date = String(dateTime).split("T");
        return `${new Date(dateTime).toLocaleString()}`;
      }
    },

    showCaptiomImg (index) {
      this.index = index;
      this.visibleCaption = true;
    },

    handleCaptionHide () {
      this.visibleCaption = false;
      this.showSingleImage = false;
    },

    async onInput (e) {
      this.vehicleNumber = await e.target.innerText;
    },

    async getNextPageRecords (page) {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        const result = await this.GetFilteredATCCRecords({
          page: page
        });

        this.perPage = result.rows;
        this.totalRows = result.totalPageNumber;
        this.allTrafficData = result.data;
        this.$store.dispatch("layout/changeLoaderValue", false);

      } catch (e) {
        console.log(e)
        Swal.fire('Failed!', 'Cannot fetch filter records now', 'error')
        this.$store.dispatch("layout/changeLoaderValue", false);
      }
    },

    async getFilteredRecords (e) {
      try {

        const data = JSON.parse(e);
        let fromDate = new Date(data.datepickervalueFrom)
        let toDate = new Date(data.datepickervalueTo)

        if (
          fromDate.toISOString().includes("1970-01-01") &&
          toDate.toISOString().includes("1970-01-01") &&
          !data.filterVehicleNumber &&
          !data.vehicleClass &&
          !data.location &&
          !data.side &&
          !data.site
        ) {
          this.$toast.warning("Please select filter options", {
            position: "top-left",
            duration: 3000,
          });
          // Swal.fire("Please select filter options", "", "warning");
          return;
        }

        toDate.setHours(23, 59, 59, 999);

        this.isDataFilterActive = true;
        this.$store.dispatch("layout/changeLoaderValue", true);
        this.toggleFilter();
        const result = await this.GetFilteredATCCRecords({
          page: this.currentPage,
          vehicleNumber: data.filterVehicleNumber,
          fromDate: fromDate.toISOString(),
          toDate: toDate.toISOString(),
          vehicleClass: data.vehicleClass,
          location: data.location,
          side: data.side,
          site: data.site,
        });

        this.perPage = result.rows;
        this.totalRows = result.totalPageNumber;
        this.allTrafficData = result.data;
        this.$store.dispatch("layout/changeLoaderValue", false);

      } catch (e) {
        console.log(e)
        Swal.fire('Failed!', 'Cannot fetch filter records now', 'error')
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.isDataFilterActive = true;
      }
    },

    resetFilter () {
      this.isDataFilterActive = false;
      this.packageFilter = null;
      this.toggleFilter();
    },
  },

  computed: {
    masters () {
      return this.$store.getters["incident/masters"];
    },
    atccStats () {
      return this.$store.getters["socket/atcc"].statistics;
    },
    trafficData () {
      return this.$store.getters["socket/atcc"].allRecords;
    },
    vehicleImages () {
      return this.selectedIncident.images
        ? this.selectedIncident.images.map((e) => e.media_url)
        : [];
    },
    currentUser () {
      return this.$store.getters["auth/user"];
    },
  },

  async mounted () {
    this.$socket.emit("REQUEST:ATCC_STATISTICS");
    this.$socket.emit("REQUEST:ATCC_TRAFFIC_ALL_RECORDS");

    this.operatorId = this.currentUser.user.id;

    const filtersData = await this.GetAtccFiltersData();

    // Locations Filter
    for (let location of filtersData.locations) {
      if (location != '') this.locationFilters.push({ location: location });
    }

    // Sites Filter
    for (let site of filtersData.sites) {
      if (site != '') this.sitesFilters.push({ site: site });
    }

    this.socketInterval = setInterval(() => {
      if (!this.isDataFilterActive) {
        this.$socket.emit("REQUEST:ATCC_STATISTICS");

        if (this.currentPage == 1) {
          this.$socket.emit("REQUEST:ATCC_TRAFFIC_ALL_RECORDS");
        }
      }
    }, 30000);

    this.$store.dispatch("layout/changeLoaderValue", false);
  },

  watch: {
    currentPage: async function () {
      await this.getNextPageRecords(this.currentPage);
    },
    trafficData: async function () {
      this.allTrafficData = this.trafficData.data;
      this.perPage = this.trafficData.rows;
      this.totalRows = this.trafficData.totalPageNumber;
    },
  },

  beforeDestroy () {
    if (this.socketInterval) {
      clearInterval(this.socketInterval);
      this.socketInterval = null;
    }
  },
};
</script>

<style scoped>
.image {
  height: 100px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
